<template>
  <div class="accountingDetail">
    <van-form label-width="120px">
      <div v-if="form.menuState == 3">
        <div class="title">{{ $t.meta.basicTitle }}</div>
        <van-field
          v-model="form.PWB_Number"
          :label="$t.salesManagement.mainWbNumber"
          readonly
        />
        <van-field
          v-model="form.WB_Number"
          :label="$t.salesManagement.sideWbNumber"
          readonly
        />
        <van-field
          v-model="form.WarehouseWorkNumber"
          :label="$t.salesManagement.warehouseWorkNumber"
          readonly
        />
        <van-field
          v-model="form.OperationUserName"
          :label="$t.salesManagement.operation"
          readonly
        />
        <van-field
          v-model="form.MarketUserName"
          :label="$t.salesManagement.marketing"
          readonly
        />
        <van-field
          v-model="form.SalesUserName"
          :label="$t.salesManagement.sales"
          readonly
        />
        <van-field
          v-model="form.CustomerServiceUserName"
          :label="$t.salesManagement.kefu"
          readonly
        />
        <div class="title">{{ $t.salesManagement.tradeTitle }}</div>
        <van-field v-model="form.POL" :label="$t.salesManagement.deliveryPort" readonly />
        <van-field
          v-model="form.POD"
          :label="$t.salesManagement.destinationPort"
          readonly
        />
        <van-field v-model="form.ATD" :label="$t.salesManagement.atd" readonly />
        <div class="title">{{ $t.salesManagement.amountTitle }}</div>
        <div class="subTotal" v-if="form.ReceivedList && form.ReceivedList.length > 0">
          <div class="subTotal-label">
            {{ $t.salesManagement.receivedAmount }}
          </div>
          <div
            class="subTotal-item"
            v-for="(item, index) in form.ReceivedList"
            :key="index"
          >
            <div class="item1">{{ item.CurrencySn }}</div>
            <div class="item2">{{ item.TotalAmount }}</div>
          </div>
        </div>
        <van-field
          v-model="form.ReceivedTotalAmount"
          :label="$t.salesManagement.receivedTotal + '(' + settlementCurrency + ')'"
          readonly
        />
        <div class="subTotal" v-if="form.PaidList && form.PaidList.length > 0">
          <div class="subTotal-label">{{ $t.salesManagement.payAmount }}</div>
          <div class="subTotal-item" v-for="(item, index) in form.PaidList" :key="index">
            <div class="item1">{{ item.CurrencySn }}</div>
            <div class="item2">{{ item.TotalAmount }}</div>
          </div>
        </div>
        <van-field
          v-model="form.PaidTotalAmount"
          :label="$t.salesManagement.paidTotal + '(' + settlementCurrency + ')'"
          readonly
        />
        <van-field
          v-model="form.ProfitsSubTotal"
          :label="$t.salesManagement.subProfit + '(' + settlementCurrency + ')'"
          readonly
        />
        <div class="subTotal" v-if="rateList && rateList.length > 0">
          <div class="subTotal-label">{{ $t.salesManagement.rate }}</div>
          <div class="subTotal-item" v-for="(item, index) in rateList" :key="index">
            <div class="item1">{{ item.CurrencySn }}</div>
            <div class="item2">{{ item.Rate }}</div>
          </div>
        </div>
      </div>
      <div v-else-if="form.menuState == 2">
        <div class="title">{{ $t.salesManagement.nuclearTitle }}</div>
        <van-field
          v-model="form.CreateTime"
          :label="$t.salesManagement.creditDate"
          readonly
        />
        <van-field
          v-model="form.NuclearAccountNo"
          :label="$t.salesManagement.nuclearAccountNo"
          readonly
        />
        <van-field
          v-model="form.CompanyNameSn"
          :label="$t.salesManagement.shortName"
          readonly
        />
        <van-field
          v-model="form.NuclearTypeStr"
          :label="$t.salesManagement.nuclearType"
          readonly
        />
        <van-field
          v-model="form.AccountNickName"
          :label="$t.salesManagement.bank"
          readonly
        />
        <div
          class="subTotal"
          v-if="form.ReceivedAmountList && form.ReceivedAmountList.length > 0"
        >
          <div class="subTotal-label">
            {{ $t.salesManagement.receivableAmount }}
          </div>
          <div
            class="subTotal-item"
            v-for="(item, index) in form.ReceivedAmountList"
            :key="index"
          >
            <div class="item1">{{ item.CurrencySn }}</div>
            <div class="item2">{{ item.TotalAmount }}</div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="title">{{ $t.meta.basicTitle }}</div>
        <van-field
          v-model="form.PWB_Number"
          :label="$t.salesManagement.mainWbNumber"
          readonly
        />
        <van-field
          v-model="form.WB_Number"
          :label="$t.salesManagement.sideWbNumber"
          readonly
        />
        <van-field
          v-model="form.WarehouseWorkNumber"
          :label="$t.salesManagement.warehouseWorkNumber"
          readonly
        />
        <van-field v-model="form.Sales" :label="$t.salesManagement.recommend" readonly />
        <van-field
          v-model="form.CompanyNameSn"
          :label="$t.salesManagement.payerName"
          readonly
        />
        <van-field
          v-model="form.InvoiceNo"
          :label="$t.salesManagement.invoiceNo"
          readonly
        />
        <van-field
          v-model="form.InvoiceDate"
          :label="$t.salesManagement.createDate"
          readonly
        />
        <div class="title">{{ $t.salesManagement.tradeTitle }}</div>
        <van-field v-model="form.POL" :label="$t.salesManagement.deliveryPort" readonly />
        <van-field
          v-model="form.POD"
          :label="$t.salesManagement.destinationPort"
          readonly
        />
        <van-field v-model="form.ATD" :label="$t.salesManagement.atd" readonly />
        <div class="title">{{ $t.salesManagement.amountTitle }}</div>
        <van-field
          v-model="form.InvoiceAmount"
          :label="$t.salesManagement.billTotal + '(' + settlementCurrency + ')'"
          readonly
        />
        <van-field
          v-model="form.OutStandingDays"
          :label="$t.salesManagement.outStandingDays"
          readonly
        />
        <van-field
          v-model="form.CreditAmountBalance"
          :label="$t.salesManagement.creditBalance"
          readonly
        />
        <div
          class="subTotal"
          v-if="form.BalanceAmountList && form.BalanceAmountList.length > 0"
        >
          <div class="subTotal-label">{{ $t.salesManagement.balance }}</div>
          <div
            class="subTotal-item"
            v-for="(item, index) in form.BalanceAmountList"
            :key="index"
          >
            <div class="item1">{{ item.CurrencySn }}</div>
            <div class="item2">{{ item.BalanceAmount }}</div>
          </div>
        </div>
        <van-field
          v-model="form.ReceivableBalance"
          :label="$t.salesManagement.totalBalance + '(' + settlementCurrency + ')'"
          readonly
        />

        <div class="subTotal" v-if="rateList && rateList.length > 0">
          <div class="subTotal-label">{{ $t.salesManagement.rate }}</div>
          <div class="subTotal-item" v-for="(item, index) in rateList" :key="index">
            <div class="item1">{{ item.CurrencySn }}</div>
            <div class="item2">{{ item.Rate }}</div>
          </div>
        </div>

        <div class="multi-table" v-if="invoiceList.length > 0">
          <van-field name="stepper" :label="$t.salesManagement.taxInvoice">
            <template #input>
              <van-stepper :min="0" :value="invoiceList.length" :disabled="true" />
            </template>
          </van-field>
          <div v-for="(item, index) in invoiceList" :key="index">
            <div class="multi-table-header">
              <div class="multi-table-title">No.{{ index + 1 }}</div>
            </div>
            <van-field
              v-model="item.TaxInvoiceNumber"
              :label="$t.salesManagement.invoiceNumber"
              readonly
            />
            <van-field :label="$t.salesManagement.invoiceFile">
              <template #input>
                <van-image
                  width="80"
                  height="80"
                  fit="contain"
                  @click="imagePreview(imgUrlFilter(item.InvoiceFileAddress))"
                  :src="imgUrlFilter(item.InvoiceFileAddress)"
                />
              </template>
            </van-field>
          </div>
        </div>
      </div>
    </van-form>

    <div class="tool-bar">
      <van-button
        type="info"
        block
        @click="gotoCreditedDetails"
        v-if="form.menuState == 2"
        >{{ $t.salesManagement.details }}</van-button
      >
      <van-button
        type="info"
        block
        @click="toBillsReceivable"
        v-if="form.menuState == 1"
        >{{ $t.salesManagement.billDetail }}</van-button
      >
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image, Uploader, Picker, Popup, Stepper } from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Uploader)
  .use(Picker)
  .use(Popup)
  .use(Stepper);

export default {
  name: "accountingDetail",
  data() {
    return {
      SettlementCurrency: "",
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      form: {},
      invoiceList: [],
      rateList: [],
    };
  },
  created() {
    var data = JSON.parse(localStorage.getItem("accountingDetail"));
    this.form = data;
    this.$commonMethod.fieldRefresh(".accountingDetail");
    this.settlementCurrency = this.form.SettlementCurrency;
    this.rateList = this.form.RateList;
    this.firstLoad();
  },
  methods: {
    firstLoad() {
      if (this.form.InvCount) {
        this.getInvoiceFileListByInvoiceNo();
      }
    },
    toBillsReceivable() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "billsReceivable",
        name: "billsReceivable",
        query: [
          {
            name: "InvoiceNo",
            value: this.form.InvoiceNo,
          },
        ],
      });
    },
    gotoCreditedDetails() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "creditedDetails",
        name: "creditedDetails",
        query: [
          {
            name: "NuclearAccountNo",
            value: this.form.NuclearAccountNo,
          },
        ],
      });
    },
    getInvoiceFileListByInvoiceNo() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          InvoiceNo: this.form.InvoiceNo,
        };
        this.$api.financialManagement
          .getInvoiceFileListByInvoiceNo(param)
          .then((res) => {
            this.invoiceList = res.data;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.accountingDetail {
  ::v-deep .number-label {
    line-height: 33px;
  }

  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }

  .van-cell::after {
    border: none !important;
  }

  .subTotal {
    padding: 15px;
    font-size: 14px;
    color: #646566;

    .subTotal-label {
      margin-bottom: 15px;
    }

    .subTotal-item {
      display: inline-block;
      width: 33.33%;
      text-align: center;

      .item1 {
        padding: 10px;
        background: #1e90ff;
        color: #ffffff;
      }

      .item2 {
        padding: 10px;
        background: #e8f4ff;
      }
    }
  }

  .multi-table {
    .multi-table-header {
      padding: 10px 15px;

      .multi-table-title {
        font-size: 14px;
        color: #999;
        display: inline-block;
        vertical-align: middle;
      }

      .multi-table-btn {
        font-size: 20px;
        color: #000;
        width: 100%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
      }
    }
  }

  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);

    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
